module.exports = __webpack_public_path__ + "img/0-125.0ae83d39.jpg";